import React, { useState } from "react";
import "./filter-location-button.component.scoped.scss";
import { Button } from "@material-ui/core";
import { icons } from "../../statics/icons";
const { homeIco } = icons;

export default function FilterLocationButton(props: any) {
  const [active, setBtnState]: any = useState(1);
  const { toggleActiveFilter } = props;

  const toggleState = () => {
    const { location } = props;
    setBtnState(!active);
    toggleActiveFilter(location);
  };

  return (
    <Button
      className={`location-btn text-capitalize ${
        props.state === "inactive" ? "" : active ? "active" : ""
      }`}
      variant="contained"
      color="primary"
      onClick={toggleState}
    >
      <img src={homeIco} alt="home" />
      <span>{props.location}</span>
    </Button>
  );
}
